import { render, staticRenderFns } from "./header.vue?vue&type=template&id=2fde7e82&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style1 from "./header.vue?vue&type=style&index=1&id=2fde7e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde7e82",
  null
  
)

export default component.exports